import { render } from "./AlbumSmallBox.vue?vue&type=template&id=1565368c&scoped=true"
import script from "./AlbumSmallBox.vue?vue&type=script&lang=js"
export * from "./AlbumSmallBox.vue?vue&type=script&lang=js"

import "./AlbumSmallBox.vue?vue&type=style&index=0&id=1565368c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1565368c"

export default script